import React from 'react';

import MokaDatePicker from 'components/receipt/invoices/RecordPaymentModal/MokaDatePicker';
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField';

import { Field } from 'redux-form';
import {
  maritalStatus,
  numberOnly,
  alphabeticalAndSomeChar,
  alphabeticalOnly,
  inputField,
  renderSelectField,
  residenceOwnership,
} from '../utilsForm';
import styles from './koinworksForm.css';

const KoinworksPersonalForm = props => {
  const { businessLocationsState } = props;

  return (
    <div className={`col-md-12 col-lg-12`}>
      <div className="col-md-3">
        <label>Personal Information</label>
      </div>
      <div className="col-md-9">
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Name
            <red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="name"
              maxLength="255"
              placeholder="Your name (Based on ID)"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphabeticalOnly()}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            NIK <red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="nik"
              maxLength="16"
              placeholder="Your NIK"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={numberOnly()}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Date of Birth
          </label>
          <div className="col-sm-8">
            <Field
              component={MokaDatePicker}
              name="birth_date"
              placeholder="DD/MM/YYYY"
              readOnly={false}
              showMonthDropdown
              showYearDropdown
              errorClassName={styles.error}
              className={`form-control ${styles['account-name']}`}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Marital Status
            <red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              name="marital_status"
              className={`form-control ${styles['bank-select']}`}
              id="marital_status"
              component={renderSelectField}
            >
              <option value="" key="">
                Select Your Marital Status
              </option>
              {maritalStatus.map(option => (
                <option value={option.name} key={option.name}>
                  {option.name}
                </option>
              ))}
            </Field>
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Personal Email<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="personal_email"
              maxLength="255"
              placeholder="Your Personal Email"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Mobile Phone Number<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={PhoneNumberField}
              name="personal_phone_number"
              type="tel"
              placeholder=""
              errorRegister
              showTextError
              customClassName={styles['account-name']}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Home Phone Number<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={PhoneNumberField}
              name="home_phone_number"
              type="tel"
              placeholder=""
              errorRegister
              showTextError
              customClassName={styles['account-name']}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
            Personal Address<red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              component={inputField}
              name="address"
              maxLength="255"
              placeholder="Your Personal Address"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphabeticalAndSomeChar()}
            />
          </div>
          <div className="col-sm-offset-4 col-sm-8">
            <Field
              component={inputField}
              name="home_city"
              maxLength="255"
              placeholder="City"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={alphabeticalAndSomeChar()}
            />
          </div>
          <div className="col-sm-offset-4 col-sm-8">
            <Field
              name="home_province"
              className={`form-control ${styles['bank-select']}`}
              id="business_location _id"
              component={renderSelectField}
            >
              <option key={0} value="">
                Select Province...
              </option>
              {businessLocationsState.map(option => (
                <option value={option.name} key={option.id}>
                  {option.name}
                </option>
              ))}
            </Field>
          </div>
          <div className="col-sm-offset-4 col-sm-8">
            <Field
              component={inputField}
              name="home_zipcode"
              maxLength="5"
              placeholder="Zip"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              className={`form-control ${styles['account-name']}`}
              normalize={numberOnly()}
            />
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="current_residence_ownership"
            className="col-sm-4 col-form-label"
          >
            Residence Ownership
            <red>*</red>
          </label>
          <div className="col-sm-8">
            <Field
              name="current_residence_ownership"
              className={`form-control ${styles['bank-select']}`}
              id="current_residence_ownership"
              component={renderSelectField}
            >
              <option value="" key="">
                Select Your Residence Ownership
              </option>
              {residenceOwnership.map(option => (
                <option value={option.name} key={option.name}>
                  {option.name}
                </option>
              ))}
            </Field>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KoinworksPersonalForm;
